<template>
  <div class="action_main">
    <div v-if="container" :style="{ ...rowStyle(container?.layout) }">
      <op-row :gutter="container.layout['grid-gutter']" :flex="isFlex" :custom-style="customStyle(container.layout)">
        <template v-for="(item, index) in container.items">
          <op-col
            v-if="customMatch(item) && showConatiner(item)"
            :key="index"
            :xs="item.layout['col-s']"
            :md="item.layout['col-m']"
            :lg="item.layout['col-l']"
            :custom-style="customStyle(item.layout)"
          >
            <!-- 如果是容器类型，套一层 OpRow 并递归渲染 -->
            <template v-if="item.type === CANTAINER_TYPE.CONTAINER">
              <op-row
                :key="item.code"
                :grid-margin="item.layout['grid-margin']"
                :gutter="item.layout['grid-gutter']"
                :flex="isFlex"
                :custom-style="customStyle(item.layout)"
              >
                <template v-for="(childItem, childIndex) in item.items">
                  <op-col
                    v-if="showModeAction(childItem.actionInfo) && customMatch(childItem.actionInfo)"
                    :key="childIndex"
                    :xs="childItem.layout['col-s']"
                    :md="childItem.layout['col-m']"
                    :lg="childItem.layout['col-l']"
                    :custom-style="customStyle(childItem.layout)"
                  >
                    <op-action-container v-if="childItem.type === CANTAINER_TYPE.CONTAINER" :container="childItem" />
                    <template v-else>
                      <slot :name="CANTAINER_TYPE.ACTION" :item="childItem" />
                    </template>
                  </op-col>
                </template>
              </op-row>
            </template>
            <!-- 如果是动作类型，渲染具体内容 -->
            <slot :name="CANTAINER_TYPE.ACTION" :item="item" />
          </op-col>
        </template>
      </op-row>
    </div>
    <div v-if="!container" class="other_action">
      <template
        v-for="(item,index) in getUnMatchedAction()"
      >
        <div
          v-if="showModeAction(item) && customMatch(item)"
          :key="index"
          class="device_div_action"
          :class="showFullRow(item) ?'full-row': ''"
        >
          <slot :name="CANTAINER_TYPE.ACTION" :item="{ actionInfo: item }" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import OpRow from './OpRow.vue'
import OpCol from './OpCol.vue'
import { isMatched, getDeviceShowMode, getSenceShowMode, getIftttShowMode } from '@utils/utils'
import { APP_SHOW_MODE_ENUM,UICONTROL_CX_CY_WithMode_ARRAY } from '@/utils/enums'

const CANTAINER_TYPE = {
  CONTAINER: 'container',
  ACTION: 'action',
}

export default {
  name: 'OpActionContainer',
  components: {
    OpRow,
    OpCol,
  },
  props: {
    //能力表排序数据
    webContainer: {
      type: Object,
      default: () => null,
    },
    //能力表
    actionList: {
      type: Array,
      default: () => [],
    },
    //针对于自动化的actionList
    allActionList: {
      type: Array,
      default: () => null,
    },
    isFlex: {
      type: Boolean,
      default: true,
    },
    //展示模式 1 设备 2 场景 3 自动化
    showMode: {
      type: Number,
      default: 1,
    },
    isVisual: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CANTAINER_TYPE,
      APP_SHOW_MODE_ENUM,
      containerLayout: {},
    }
  },
  computed: {
    container() {
      return this.mixinUIActionList(this.webContainer, this.actionList)
    },
  },
  methods: {
    isMatched: isMatched,
    getDeviceShowMode: getDeviceShowMode,
    /**
     * 将ActionList混入到UI上
     * @param {Object} abiliy
     * @param {Array} actionList
     * @returns {Object}
     */
    mixinUIActionList(abiliy, actionList) {
      if (!Boolean(abiliy)) {
        return null
      }
      let ability = JSON.parse(JSON.stringify(abiliy))
      let action = []
      action = actionList.filter(item => this.showModeAction(item))
      /* 详情的数据结构和场景自动化不一样 */
      if (this.showMode === this.APP_SHOW_MODE_ENUM.DEVICE) {
        action = actionList.flatMap(item => item.ActionList)
      }
      action.forEach(item => {
        item.hasMatched = false
        if (item.Values) {
          item.Values.forEach(value => {
            this.$set(value, 'disabled', false)
          })
        }
      })
      this.processItems(ability.items, action)
      this.getUnMacthLayout(ability)
      return ability
    },
    /**
     * 递归处理将Action通过code匹配到UI上
     * @param {Array} actionUI
     * @param {Array} actionInfo
     */
    processItems(actionUI, actionInfo) {
      try {
        function findActionInfoByCode(code) {
          return actionInfo?.find(info => {
            return info.Code === code && !info.hasMatched
          })
        }
        actionUI.forEach(item => {
          if (item.type === CANTAINER_TYPE.ACTION) {
            const matchingInfo = findActionInfoByCode(item.code) || {}
            if (matchingInfo) {
              matchingInfo.hasMatched = true // 标记已匹配
              this.matchValueType(matchingInfo, item)
              item.actionInfo = matchingInfo
            }
          } else if (item.type === CANTAINER_TYPE.CONTAINER && item.items) {
            this.processItems(item.items, actionInfo)
          }
        })
      } catch (error) {
        console.log('........error', error)
      }
    },
    /**
     * 修改相应的valueType
     */
    matchValueType(action, UI) {
      try {
        const { ValueType } = UI
        if (!ValueType || !action?.Values) return
        const values = action.Values.filter(item => item.IsShow)
        if (values.length > 0) {
          values[0].ValueType = ValueType
        }
      } catch (error) {
        console.log('........修改相应的valueType', error)
      }
    },
    /**
     * 获取未匹配的设备
     */
    getUnMatchedAction() {
      let action = this.actionList
      if (this.showMode === this.APP_SHOW_MODE_ENUM.DEVICE) {
        action = this.actionList.map(item => Array.isArray(item.ActionList) ? item.ActionList : item).flat()
      }
      action = action.filter(item => !item.hasMatched)
      return action
    },
    /**
     * 场景,详情,自动化是否显示
     */
    showModeAction(info) {
      if (this.showMode === this.APP_SHOW_MODE_ENUM.DEVICE) {
        return getDeviceShowMode(info)
      } else if (this.showMode === this.APP_SHOW_MODE_ENUM.SENCE) {
        return getSenceShowMode(info)
      } else {
        return getIftttShowMode(info)
      }
    },
    /**
     * 是否全屏展示
     */
    showFullRow(info) {
      if (this.showMode === this.APP_SHOW_MODE_ENUM.DEVICE) {
        const values = (info?.Values || []).filter(item => item.IsShow)
        const ValueType = values?.[0]?.ValueType || ''
        return ValueType == 'UIControl_Switch' ||  UICONTROL_CX_CY_WithMode_ARRAY.includes(ValueType) || ValueType == 'UIControl_TianMu_Video_Group'
      }

      if (this.showMode === this.APP_SHOW_MODE_ENUM.IFTTT || this.showMode === this.APP_SHOW_MODE_ENUM.SENCE) {
        const values = (info?.Values || []).filter(item => item.IsShow)
        const ValueType = values?.[0]?.ValueType || ''
        return ValueType == 'UIControl_RadioboxList'
      }

      return false
    },
    /**
     * 判断action是否显示
     * @param {*} action
     * @param {*} list
     * @param {*} info
     */
    customMatch(action) {
      if (this.showMode === this.APP_SHOW_MODE_ENUM.IFTTT) {
        return isMatched(action, this.allActionList || this.actionList, this.showMode)
      }
      return isMatched(action, this.actionList, this.showMode)
    },
    /**
     * 判断容器是否显示
     * @param {*} list
     */
    showConatiner(item) {
      // return true
      if (item.type === CANTAINER_TYPE.ACTION) {
        return true
      }
      const show = item.items.filter(item => this.showModeAction(item.actionInfo) && this.customMatch(item.actionInfo))
      return show.length > 0
    },
    /**
     * 容器扩展样式
     * @param {Object} layout
     * @returns {Object}
     */
    customStyle(layout) {
      if (!layout && typeof layout === 'object') {
        return {}
      }

      return {
        ...layout,
      }
    },
    /**
     * row的边距
     * @param {Object} layout
     * @returns {Object}
     */
    rowStyle(layout) {
      if (!layout && layout['grid-margin']) {
        return {}
      }

      return {
        margin: `0px ${layout['grid-margin'] || '0'}px`,
      }
    },
    getUnMacthLayout(ability) {
      if (ability) {
        const { items } = ability
        if (items && Array.isArray(items)) {
          const find = items.find(_in => {
            return _in.type === CANTAINER_TYPE.CONTAINER && _in.items && _in.items.length > 0
          })
          if (find) {
            const un_item = this.getUnMatchedAction().map(item => {
              return {
                actionInfo: item,
                layout: {
                  'col-s': 4,
                  'col-m': 8,
                  'col-l': this.showFullRow(item)?12:6,
                },
                type:CANTAINER_TYPE.ACTION
              }
            })
            items.push({
              items: un_item,
              layout: find?.layout || {},
              type: CANTAINER_TYPE.CONTAINER,
            })
          }
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.other_action {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  flex-direction: row;

  .device_div_action {
    width: 50%;
    padding-left: 2%;
    padding-right: 2%;
    box-sizing: border-box;
  }

  .full-row {
    width: 100%;
  }
}

.action_main {
  width: 100%;
}
</style>
